
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'BotaoTopo',
    data() {
        return {
            visivel: false
        };
    },
    mounted() {
        window.addEventListener('scroll', this.aoRolar, { passive: true });
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.aoRolar);
    },
    methods: {
        aoRolar() {
            this.visivel = window.scrollY > 600;
        },
        subir() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }
});
